import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button, Typography } from "@digital-services/ui";

import PageContentCentered from "@components/PageContentCentered";

import LockIcon from "@icons/lock-96.svg?react";

import { msalInstance } from "../../msalInstance";

export const UnAuthorizedPage: FunctionComponent = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "account.unauthorized"
  });
  return (
    <div data-testid="unauthorized-page-content">
      <PageContentCentered withNegativeMarginLeft>
        <div className="mb-8">
          <LockIcon />
        </div>
        <Typography
          className="mb-2"
          variant="pageTitle"
          data-testid="page-title"
        >
          {t("page_title")}
        </Typography>

        <div className="text-[18px]">{t("message1")}</div>
        <div className="text-[18px]">{t("message2")}</div>

        <Button
          size="big"
          className="mt-6"
          onClick={() => {
            msalInstance.loginRedirect();
          }}
          variant="primary"
        >
          {t("signIn")}
        </Button>
      </PageContentCentered>
    </div>
  );
};
